'use client';

import { Button, ButtonProps } from '@mui/material';
import React, { ElementType, FC } from 'react';

interface CustomButtonProps extends Omit<ButtonProps, 'component'> {
	href?: string;
	onClick?: () => void;
	name: string;
	'data-cy'?: string;
	rel?: string;
	target?: string;
	disabled?: boolean;
	theme: any;
}

export const InverseButton: FC<CustomButtonProps> = (props) => {
	const { href, onClick, name, 'data-cy': dataCy, rel, target, disabled, fullWidth, theme, ...rest } = props;

	const Component: ElementType = href ? 'a' : 'button';

	return (
		<Button
			component={Component}
			href={href}
			fullWidth={fullWidth}
			variant='outlined'
			data-cy={dataCy}
			onClick={onClick}
			rel={href ? rel : undefined}
			target={href ? target : undefined}
			disabled={disabled}
			{...rest}
		>
			{name}
		</Button>
	);
};
